/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useCallback } from 'react';
import { mergeClasses } from '@fluentui/react-components';

import { useAccordionContext } from '../contexts/accordion';
import { useFormCardHeaderStyles } from './card-header-styles';

const isElementInteractive = (element: HTMLElement) => element.matches('button, a[href], input, select, textarea, [tabindex], [role="button"]');

export const FormCardHeader: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const classes = useFormCardHeaderStyles();

  const accordionContext = useAccordionContext();
  const isCollapsable = !!accordionContext;

  const handleClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    // Prevent the click event from bubbling up to the card body
    if (!isCollapsable || isElementInteractive(e.target as HTMLElement)) { return; }

    accordionContext.onOpenChange(!accordionContext.open);
  }, [accordionContext, isCollapsable]);

  return (
    <div
      className={mergeClasses('card-header', classes.root, (isCollapsable && accordionContext.open) && classes.divider)}
      onClick={isCollapsable ? handleClick : undefined}
    >
      {children}
    </div>
  );
};
